import React from 'react';
import BrandTitle from 'components/common/BrandTitle';

import {
  Wrapper, SubTitle, List, ListItem, ButtonWrapper,
} from './styles';
import Button from '../Button';

const DesktopBanner = () => (
  <Wrapper>
    <BrandTitle />

    <SubTitle>Our most powerful powersports pricing tool ever:</SubTitle>

    <List>
      <ListItem>Uses AI to determine an estimated value, keeping seasonal and market adjustments in mind</ListItem>
      <ListItem>Find values on up to 20 model years in nearly every major powersport category</ListItem>
      <ListItem>Proprietary algorithm with regular updates for the most accurate estimation</ListItem>
      <ListItem>Access to interactive charts and transaction history, even if a value can’t be provided</ListItem>
    </List>

    <ButtonWrapper>
      <Button style={{ float: 'left' }} onClick={() => window.open('https://www.npauctions.com/Media/Dealer%20Docs/VGProHowTo.pdf?ct=t')}>How-To Guide</Button>
    </ButtonWrapper>
  </Wrapper>
);

export default DesktopBanner;
